interface IProps {
  color: any;
}

export const ArrowRight = ({ color }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M8 15L13 10L8 5"
        stroke={color}
        strokeWidth="3"
        strokeLinecap-="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
